import { defineComponent } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';

const templateElement = document.getElementById('wishlist-container-template');

export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',
  props: {
    mandatoryDimension: {
      type: String,
      required: false,
    },
    isInitialArticle: {
      type: Boolean,
      required: true,
    },
    idChain: {
      type: Object,
      required: false,
    },
    syanColorsOnWishlist: String,
    placement: String,
    size: String,
  },
  emits: ['bewerten-vue-dimension-select'],
  setup(props) {
    const catchIncompleteDataClick = (e: Event) => {
      if (props.isInitialArticle && props.mandatoryDimension === 'colors') {
        e.preventDefault();
        e.stopPropagation();

        EventBus.emit('ents:vue:dimension:select', {
          dimension: 'colors',
        });
      }
    };

    // Expose the method to the template
    return {
      catchIncompleteDataClick,
    };
  },
});
